module.exports = __webpack_public_path__ + "static/media/swipping_dai_hand_broom.6bbea538.png";